<div class="row">
	<div class="col-sm-12">
		<app-tender-list-filters
			#listfilters
			[searchparams]="advancedSearch">
		</app-tender-list-filters>
	</div>
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right btn btn-sm btn-primary"
				(click)="edit()">
				<i
					container="body"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					[rowClass]="rowClass"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					(activate)="onActivate($event)"
					[messages]="{
          emptyMessage: 'labels.empty-tenders' | translate,
          totalMessage: 'labels.total' | translate
		}">
					<ngx-datatable-column
						prop="id"
						[flexGrow]="0.5"
						[name]="'labels.id' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								routerLink="/tender/view/{{row.id}}"
								class="link"
								ngbTooltip="{{'labels.details' | translate}}">
								{{value}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="name"
						[flexGrow]="2"
						[name]="'labels.fname' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								routerLink="/tender/view/{{row.id}}"
								class="link"
								ngbTooltip="{{'labels.details' | translate}}">
								{{value}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="startdate"
						[flexGrow]="2"
						[name]="'tender.startdate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="stopdate"
						[flexGrow]="2"
						[name]="'tender.stopdate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="projectdeadline"
						[flexGrow]="3"
						[name]="'tender.projectdeadline' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1.5"
						[name]="'labels.status' | translate"
						[resizeable]="false"
						[sortable]="false">
						<ng-template
							let-row="row"
							ngx-datatable-cell-template>
							<span [class]="'badge badge-' + (row.isOpen ? 'success' : 'danger')">
								{{(row.isOpen ? 'tender.open' : 'tender.closed') | translate}}
							</span>

						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">
								<a
									(click)="createProject(row)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.project-create' | translate}}"
										class="feather icon-plus"></i>
								</a>
								<a
									(click)="edit(row.id)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.edit' | translate}}"
										class="feather icon-edit"></i>
								</a>
								<a
									(click)="delete(row, $event)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>
